import React from 'react';
import { makeStyles, useTheme } from '~/lib/bn-material-ui';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => {
  return {
    fill: {
      minWidth: 'inherit',
      position: 'absolute',
      bottom: '0',
      background: 'transparent',
    },
    high: {
      background: theme.palette.fillLevel.high,
    },
    medium: {
      background: theme.palette.fillLevel.medium,
    },
    low: {
      background: theme.palette.fillLevel.low,
    },
  };
});

/**
 * @returns {'high' | 'medium' | 'low' | undefined}}
 */
export function getFillThreshold(fillRatio) {
  if (!Number.isFinite(fillRatio)) {
    return undefined;
  }

  let fillThreshold;
  if (fillRatio > 0.5) {
    fillThreshold = 'high';
  } else if (fillRatio > 0.3) {
    fillThreshold = 'medium';
  } else {
    fillThreshold = 'low';
  }
  return fillThreshold;
}

export function useFillColor(fillRatio) {
  const theme = useTheme();
  return getFillColor({ theme, fillRatio });
}

export function getFillColor({ theme, fillRatio }) {
  const fillThreshold = getFillThreshold(fillRatio);
  return theme.palette.fillLevel[fillThreshold];
}

export default function BinLevelFill({ volume, totalVolume, className }) {
  const styles = useStyles();
  const fillRatio = Math.min(volume / totalVolume, 1);
  const fillThreshold = getFillThreshold(fillRatio);
  if (volume === undefined || !totalVolume) {
    return <div className={styles.fill} />;
  }

  return (
    <div
      style={{ height: `${fillRatio * 100}%` }}
      className={classNames(styles[fillThreshold], styles.fill, className)}
    />
  );
}
